function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSezione05Popup0301Img01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 343.36 547.19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M88.61,220.26l21.94-.88c22.73,79.59,67.96,256.68,76.93,292.4.97,3.86,2.65,9.42,5.18,12.37,3.62,4.21,8.24,7.57,13.67,13.45,3.04,3.29.47,8.9-3.86,8.9l-68.5-.28c-4.86-.02-9.03-3.66-10.01-8.72l-30.16-155.48-5.2-161.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.47,547.19c2.35,0,4.47-1.52,5.4-3.87.87-2.19.46-4.57-1.06-6.22-2.74-2.96-5.3-5.32-7.56-7.4-2.31-2.13-4.31-3.96-6.09-6.03-1.87-2.18-3.57-6.24-5.03-12.08-12.82-51.06-54.51-214.24-77.09-291.66-.08-.29-.33-.49-.62-.49l-21.79.11c-.35,0-.67.3-.67.69,0,.39.28.71.65.71l21.32-.12c22.61,77.59,64.14,240.18,76.93,291.12,1.52,6.06,3.32,10.32,5.34,12.66,1.83,2.13,3.96,4.08,6.2,6.15,2.24,2.06,4.78,4.4,7.48,7.32,1.16,1.25,1.45,3.01.79,4.69-.72,1.83-2.36,3.01-4.18,3.01l-68.49-.29c-4.52-.02-8.46-3.45-9.37-8.15l-30.16-155.48c-.07-.38-.42-.62-.78-.55-.36.08-.59.45-.51.83l30.16,155.48c1.04,5.35,5.52,9.25,10.66,9.27l68.5.28Z",
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.18,276.47s4.88,187.52,12.56,237.95c.87,5.72,3.24,11.06,6.82,15.42l7.92,9.63c2.25,2.74.42,7.03-3,7.03H41.62c-5.15,0-9.33-4.45-9.31-9.93.16-45.77.93-226.8.11-258.33-.93-35.9,28.84-56.1,28.84-56.1l27.34-1.87,1.57,56.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.56,544.08c-1.88-2.01-2.92-4.68-2.91-7.52l.05-14.83c.22-58.72.81-214.7.06-243.47-.93-35.88,28.84-56.51,29.14-56.71.08-.05.16-.09.25-.1l27.34-1.87c.33-.07.66.16.74.51l1.57,56.21c.01.05.02.11.02.16.05,1.88,4.96,188.04,12.55,237.85.85,5.59,3.16,10.8,6.67,15.07l7.92,9.63c1.22,1.48,1.5,3.51.73,5.29-.76,1.79-2.38,2.9-4.23,2.9H41.62c-2.67,0-5.18-1.11-7.06-3.12M88.12,221.05l-26.61,1.74c-1.97,1.39-29.31,21.41-28.42,55.42.75,28.79.16,184.79-.06,243.52l-.05,14.83c0,2.46.89,4.78,2.52,6.53,1.64,1.74,3.81,2.7,6.13,2.7h72.86c1.32,0,2.48-.8,3.03-2.07.55-1.28.35-2.74-.52-3.79l-7.92-9.63c-3.68-4.47-6.09-9.92-6.98-15.77-7.54-49.5-12.44-233.19-12.56-237.96l-1.4-55.51Z",
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.23,528.99c14.26,0,28.5-1.38,42.59-4.14.36-.07.59-.44.53-.82-.07-.38-.41-.64-.77-.56-23.75,4.65-47.93,5.37-71.88,2.13-.36-.05-.69.22-.74.61-.05.38.21.74.57.78,9.87,1.34,19.79,2,29.7,2",
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.8,530.76c14.26,0,28.5-1.38,42.59-4.14.36-.07.59-.44.53-.82-.07-.38-.41-.64-.77-.56-23.75,4.65-47.93,5.37-71.88,2.13-.36-.05-.69.22-.74.61-.05.38.21.74.57.79,9.87,1.33,19.79,2,29.7,2",
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.34,
    y: 226.75,
    width: 24.64,
    height: 73.65,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.12,61.88c0,33.93-27.5,61.43-61.43,61.43s-61.43-27.5-61.43-61.43S167.77.45,201.69.45s61.43,27.5,61.43,61.43",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.69,123.31c-33.93,0-61.43-27.5-61.43-61.43S167.77.45,201.69.45c26.62,0,49.28,16.93,57.81,40.61l-57.81,82.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.69,123.75c-34.12,0-61.87-27.76-61.87-61.88S167.58,0,201.69,0c26.02,0,49.42,16.44,58.23,40.9.08.23-.04.49-.27.57-.23.08-.49-.04-.57-.27C250.4,17.09,227.34.89,201.69.89c-33.63,0-60.98,27.36-60.98,60.98s27.36,60.98,60.98,60.98c.25,0,.45.2.45.44s-.2.45-.45.45",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.7,48.83c0-14.37-11.64-26.01-26.01-26.01s-26.01,11.64-26.01,26.01c0,11.08,6.93,20.54,16.7,24.29v11.54h18.62v-11.54c9.76-3.75,16.7-13.2,16.7-24.29",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.01,85.1h-18.62c-.25,0-.44-.2-.44-.45v-11.23c-10-3.97-16.7-13.81-16.7-24.59,0-14.59,11.87-26.45,26.45-26.45s26.45,11.87,26.45,26.45c0,10.77-6.7,20.62-16.7,24.59v11.23c0,.25-.2.45-.45.45M192.83,84.21h17.73v-11.09c0-.18.11-.35.29-.42,9.82-3.77,16.41-13.36,16.41-23.87,0-14.1-11.47-25.56-25.56-25.56s-25.56,11.47-25.56,25.56c0,10.51,6.6,20.1,16.41,23.87.17.07.29.23.29.42v11.09Z",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.5,101.37c-1.02,0-1.96-.2-2.82-.59-2.91-1.32-3.81-4.38-3.85-4.51-.04-.13-.01-.28.07-.39.08-.11.22-.18.36-.18h15.16v-5.13h-17.9c-.25,0-.45-.2-.45-.44s.2-.45.45-.45h18.35c.25,0,.45.2.45.45v6.02c0,.25-.2.45-.45.45h-14.97c.38.88,1.32,2.55,3.15,3.38,1.87.85,4.22.63,6.97-.66.22-.1.49,0,.59.21.11.22.01.49-.21.59-1.78.84-3.42,1.25-4.91,1.25",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.22,77.71c-.21,0-.39-.14-.44-.36l-7.3-35.81c-.05-.24.11-.48.35-.53.24-.05.48.11.53.35l7.3,35.81c.05.24-.11.48-.35.53-.03,0-.06,0-.09,0",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.17,77.71s-.06,0-.09,0c-.24-.05-.4-.28-.35-.53l7.3-35.81c.05-.24.29-.4.53-.35s.4.28.35.53l-7.3,35.81c-.04.21-.23.36-.44.36",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.84,45s-.03,0-.05,0c-.2-.02-.35-.17-.39-.37l-.92-5.63-1.55,3.12c-.07.15-.23.25-.4.25h-2.11c-.25,0-.45-.2-.45-.45s.2-.44.45-.44h1.83l2.04-4.11c.08-.17.27-.27.47-.24.19.03.34.18.37.37l.9,5.47,2.04-4.82c.07-.17.23-.27.42-.27.18,0,.35.12.41.3l1.17,3.31h2.62c.25,0,.44.2.44.44s-.2.45-.44.45h-2.93c-.19,0-.36-.12-.42-.3l-.89-2.52-2.19,5.19c-.07.17-.23.27-.41.27",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.5,220.7c0,26.01-21.09,47.1-47.1,47.1s-47.1-21.09-47.1-47.1,21.09-47.1,47.1-47.1,47.1,21.09,47.1,47.1",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.79,246.52c-8.42,12.81-22.92,21.27-39.39,21.27-26.01,0-47.1-21.09-47.1-47.1,0-8.96,2.5-17.34,6.85-24.47l79.65,50.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.4,268.24c-26.22,0-47.54-21.33-47.54-47.55,0-8.73,2.39-17.28,6.91-24.7.13-.21.4-.28.61-.15.21.13.28.4.15.61-4.44,7.28-6.78,15.66-6.78,24.23,0,25.73,20.93,46.65,46.65,46.65,15.77,0,30.35-7.88,39.02-21.07.13-.21.41-.26.62-.13.21.14.26.41.13.62-8.83,13.45-23.7,21.48-39.77,21.48",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.42,227.01c.38,1.94,2.26,3.2,4.2,2.82l.22-.04c1.68,5.1,4.68,9.49,8.55,12.83l-.13.19c-1.1,1.64-.66,3.86.98,4.96,1.64,1.1,3.87.66,4.96-.98l.13-.19c4.57,2.3,9.76,3.42,15.12,3.03l.04.22c.38,1.94,2.27,3.2,4.2,2.82,1.94-.38,3.2-2.27,2.82-4.2l-.04-.22c5.1-1.68,9.49-4.68,12.83-8.55l.19.13c1.64,1.1,3.86.66,4.96-.98,1.1-1.64.66-3.86-.98-4.97l-.19-.13c2.31-4.57,3.42-9.76,3.03-15.12l.22-.04c1.94-.38,3.2-2.26,2.82-4.2-.38-1.94-2.27-3.2-4.2-2.82l-.22.04c-1.68-5.1-4.68-9.49-8.55-12.83l.13-.19c1.1-1.64.66-3.86-.98-4.96-1.64-1.1-3.86-.66-4.96.98l-.13.19c-4.56-2.3-9.76-3.42-15.12-3.03l-.04-.22c-.38-1.94-2.27-3.2-4.2-2.82-1.94.38-3.2,2.26-2.82,4.2l.04.22c-5.1,1.68-9.49,4.68-12.83,8.55l-.19-.13c-1.64-1.1-3.87-.66-4.97.98-1.1,1.64-.66,3.87.98,4.97l.19.13c-2.3,4.57-3.42,9.76-3.03,15.12l-.22.04c-1.94.38-3.2,2.26-2.82,4.2M217.52,206.14c8.04-1.59,15.84,3.64,17.43,11.68,1.59,8.04-3.64,15.84-11.68,17.43-8.04,1.59-15.84-3.64-17.43-11.68-1.59-8.04,3.64-15.84,11.68-17.43",
    style: {
      fill: "#5b6faf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.92,130.77c0,25.66-20.8,46.47-46.46,46.47s-46.47-20.8-46.47-46.47,20.8-46.47,46.47-46.47,46.46,20.8,46.46,46.47",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.42,85.62c3.54-.86,7.23-1.32,11.04-1.32,25.66,0,46.46,20.8,46.46,46.47s-20.8,46.47-46.46,46.47c-9.22,0-17.82-2.69-25.05-7.32l14.01-84.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.45,177.68c-9,0-17.75-2.56-25.29-7.39-.21-.13-.27-.41-.13-.62.13-.21.41-.27.62-.13,7.4,4.74,15.98,7.25,24.8,7.25,25.38,0,46.02-20.64,46.02-46.02s-20.64-46.02-46.02-46.02c-3.69,0-7.37.44-10.93,1.31-.24.06-.48-.09-.54-.33-.06-.24.09-.48.33-.54,3.62-.88,7.37-1.33,11.14-1.33,25.87,0,46.91,21.05,46.91,46.91s-21.04,46.91-46.91,46.91",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "276.19 146.74 291.99 122.04 301.98 137.66 319.63 108.8 276.19 146.74",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.19,147.18c-.08,0-.17-.02-.24-.07-.21-.13-.27-.41-.14-.62l15.8-24.7c.08-.13.22-.2.38-.2s.29.08.37.2l9.61,15.02,16.77-27.43c.13-.21.4-.28.61-.15.21.13.28.4.15.61l-17.15,28.04c-.08.13-.22.21-.37.21-.16,0-.3-.08-.38-.2l-9.62-15.03-15.43,24.11c-.08.13-.23.21-.38.21",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "320.7 114.04 319.82 114.22 318.95 109.91 314.72 111.1 314.48 110.24 319.63 108.8 320.7 114.04",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.32,153.19h-49.74c-.25,0-.44-.2-.44-.45v-43.94c0-.25.2-.45.44-.45s.45.2.45.45v43.5h49.29c.25,0,.45.2.45.44s-.2.45-.45.45",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.89,63.97c2.3-3.75,3.93-8.31,2.66-12.52-1.41-4.68-5.93-7.61-10.12-10.14-9.36-5.64-19.48-11.48-30.39-10.8-12.5.77-23.14,10.3-28.66,21.54-3.66,7.44-5.51,15.94-4.11,24.11,1.4,8.17,6.32,15.9,13.7,19.68,7.62,3.9,17.07,3.21,24.74-.59,7.52-3.73,11.77-9.66,16.9-15.94,4.65-5.69,11.26-8.76,15.28-15.33",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.34,83.33l-18.35,37.16s21.03,25.92,36.88,24.9c15.85-1.02,12.9-18.96,1.09-24.53l-8.46-1.3,10.77-28.99-21.92-7.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.85,122.44c-.05,0-.1,0-.15-.03-.23-.08-.35-.34-.27-.57l11.26-30.98-21.12-6.98-15.76,31.92c-.11.22-.38.31-.6.2-.22-.11-.31-.38-.2-.6l15.93-32.26c.1-.2.33-.29.54-.23l21.92,7.25c.11.04.21.12.26.23.05.11.06.23.02.35l-11.41,31.41c-.07.18-.24.29-.42.29",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4,121.07s-.05,0-.07,0l-6.29-.96c-.24-.04-.41-.26-.37-.51.04-.24.26-.41.51-.37l6.29.96c.24.04.41.26.37.51-.03.22-.22.38-.44.38",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.34,71.42c.8,4.35.82,8.94-.65,13.11-1.47,4.17-4.57,7.89-8.7,9.47-3.58,1.37-7.69,1.04-11.23-.44-3.54-1.48-6.55-4.04-9.01-6.98-3.78,1.34-8.39-.22-10.56-3.59-1.26-1.94-1.7-4.53-.67-6.61,1.03-2.08,3.73-3.32,5.82-2.33,1.19.56,2.04,1.71,3.26,2.23,1.35.57,2.97.23,4.19-.59,1.22-.82,2.1-2.06,2.8-3.36,2.2-4.07,2.86-8.96,1.81-13.47.1.43,2.36,1.07,2.77,1.21,1.02.34,2.06.6,3.12.76,2.09.32,4.23.3,6.32-.06,1.06-.18,2.1-.45,3.11-.81.8-.29,1.84-1.04,2.7-1.05,1.79-.02,2.32,3.24,2.75,4.5.9,2.62,1.69,5.28,2.19,8",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.12,95.32c-2.16,0-4.4-.45-6.52-1.34-3.23-1.35-6.26-3.66-8.99-6.87-3.89,1.22-8.58-.44-10.79-3.87-1.46-2.26-1.73-4.96-.7-7.04,1.19-2.4,4.18-3.59,6.41-2.53.62.29,1.15.73,1.65,1.14.52.43,1.01.84,1.59,1.08,1.12.47,2.57.26,3.77-.55.99-.67,1.83-1.68,2.65-3.2,2.15-3.97,2.79-8.76,1.77-13.16,0,0,0,0,0,0-.06-.24.09-.48.33-.53.21-.05.43.06.51.26.14.13.65.38,2.22.87.12.04.22.07.28.09.98.33,2.01.58,3.05.74,2.04.32,4.12.3,6.17-.06,1.04-.18,2.06-.45,3.04-.79.26-.09.55-.24.86-.4.65-.33,1.32-.67,1.98-.68h.02c1.8,0,2.48,2.41,2.92,4.01.08.3.16.57.23.79,1.07,3.12,1.77,5.68,2.21,8.07.92,4.99.69,9.48-.67,13.34-1.61,4.57-4.96,8.21-8.96,9.74-1.56.6-3.27.89-5.03.89M68.75,86.14c.13,0,.26.06.34.16,2.69,3.22,5.67,5.53,8.84,6.85,3.65,1.53,7.62,1.68,10.89.43,3.76-1.44,6.92-4.88,8.44-9.21,1.31-3.71,1.52-8.05.63-12.88-.43-2.34-1.12-4.86-2.18-7.94-.08-.23-.16-.51-.25-.84-.37-1.34-.94-3.36-2.07-3.36h-.01c-.45,0-1.03.3-1.59.58-.34.17-.66.34-.97.44-1.02.36-2.09.64-3.18.83-2.15.37-4.32.39-6.46.06-1.09-.17-2.17-.43-3.2-.78-.05-.02-.14-.05-.26-.08-.74-.23-1.3-.42-1.72-.6.75,4.31.01,8.89-2.06,12.74-.89,1.65-1.82,2.76-2.94,3.51-1.45.97-3.22,1.22-4.61.63-.69-.29-1.26-.76-1.8-1.21-.49-.4-.95-.78-1.47-1.03-1.77-.84-4.27.17-5.23,2.12-.88,1.78-.62,4.2.65,6.17,2.06,3.19,6.47,4.69,10.04,3.42.05-.02.1-.03.15-.03M75.82,58.78h0s0,0,0,0Z",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.37,79.54c2.11-.11,4.22,1.16,5.12,3.08l-5.12-3.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.49,83.06c-.17,0-.33-.1-.4-.26-.82-1.76-2.75-2.92-4.69-2.82-.25.02-.46-.18-.47-.42-.01-.25.18-.46.42-.47,2.3-.12,4.57,1.25,5.54,3.33.1.22,0,.49-.21.59-.06.03-.13.04-.19.04",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.26,241.61c-7.75-4.04-12.65-11.97-16.37-19.88C4.17,203.12-.07,182.5,0,161.95c.03-10.19,1.3-20.91,7.25-29.18,6.45-8.95,17.47-13.6,28.37-15.24,4.39-.66,9.06-.87,13.11.96,5.26,2.37,8.47,7.65,12.43,11.85,4.61,4.88,10.56,8.48,17.02,10.31,4.13,1.16,9.11,1.45,11.81-2.5,1.21-1.77,1.58-3.96,1.3-6.09-.59-4.46-3.51-7.9-6.34-11.19,5.43-.88,11.02,1.29,15.3,4.74,4.29,3.45,7.46,8.07,10.35,12.75,8.83,14.31,15.62,29.81,21.05,45.72,1.92,5.63,3.7,11.51,3.09,17.43-.69,6.69-1.94,13.08-6.88,17.65-1.6,1.48-3.12,2.8-4.44,3.91-2.52,2.12-5.82,3-9.08,2.55-17.95-2.47-61.36,11.6-65.03,14.58-5.53,4.48-13.88,4.64-20.06,1.42",
    style: {
      fill: "#5b6faf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.99,186.92c-.19,0-.36-.12-.42-.31l-8.58-26.92c-.07-.23.05-.48.29-.56.24-.07.48.06.56.29l8.58,26.92c.07.23-.05.48-.29.56-.05.01-.09.02-.14.02",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.6,176.59c-.22,0-.41-.16-.44-.38-1.07-7.47-2.92-14.85-5.48-21.95-.08-.23.04-.49.27-.57.23-.08.49.04.57.27,2.58,7.15,4.44,14.6,5.52,22.12.04.24-.13.47-.38.5-.02,0-.04,0-.06,0",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.89,233.81c.3.98.73,2.1,1.71,2.42.77.26,1.71.08,2.34-.43,13.5-11.02,24.27-18.12,40.27-25,2.03-.88-1.18,8,10.39.07,1.83-1.25.3-4.98-1.88-5.35,1.8-.25,3.35-1.81,3.58-3.62.23-1.81-.87-3.71-2.55-4.4,1.75.33,3.37-1.42,3.46-3.19.08-1.78-.97-3.42-2.23-4.67,4.84,2.35,11.62,9.2,15.46,4.58,1.03-4.68-2.24-7.16-5.87-10.29-3.63-3.12-8.36-4.67-13.06-5.56-10.46-1.97-21.35-.99-31.58,1.97-9,2.61-17.56,6.7-25.5,11.64-1.95,1.21-2.6,1.47-2.63,3.73-.03,2.42.67,5.07,1.05,7.46.78,4.96,1.73,9.89,2.85,14.79,1.21,5.33,2.62,10.62,4.22,15.86",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.49,211.05c-.19,0-.36-.12-.42-.31-.07-.23.05-.48.29-.56l4.63-1.48c.23-.08.48.05.56.29.07.23-.05.48-.29.56l-4.62,1.48s-.09.02-.14.02",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.22,204.06c-.13,0-.26-.05-.34-.16-.16-.19-.13-.47.06-.63,4.64-3.81,9.75-7.04,15.19-9.59.22-.1.49,0,.59.21.1.22,0,.49-.21.59-5.37,2.52-10.42,5.71-15.01,9.48-.08.07-.18.1-.28.1",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.82,215.16c.07,3.05.95,6.32,3.35,8.2,3.1,2.41,7.54,1.73,11.31.64,17.91-5.15,34.06-15.08,43.35-31.24.38-.67,3.79-8.83,2.4-10.68-1.31-1.73-4.57,1.56-6.7,2.01-9.22,1.94-18.32,4.45-27.23,7.52-4.58,1.58-9.11,3.3-13.57,5.18-3.42,1.43-6.32,1.82-8.6,4.91-2.84,3.85-4.41,8.66-4.29,13.45",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.48,224.45c-.19,0-.37-.13-.43-.32-.07-.24.07-.48.31-.55,19.79-5.69,34.69-16.42,43.08-31.03.53-.91,3.56-8.69,2.43-10.19-.15-.2-.11-.48.09-.62.2-.15.48-.11.62.09,1.7,2.24-2.32,11.09-2.36,11.17-8.51,14.82-23.59,25.69-43.61,31.44-.04.01-.08.02-.12.02",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.77,166.46h-32.92c-.7,0-1.37.32-1.8.87l-26.54,33.77c-1.18,1.5-.11,3.7,1.8,3.7h31.78c.69,0,1.34-.31,1.77-.84l27.68-33.77c1.22-1.49.16-3.74-1.77-3.74",
    style: {
      fill: "#1d1d1b"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSezione05Popup0301Img01);
export default __webpack_public_path__ + "static/media/sezione-05-popup-03-01-img-01.22c4d91a2f3820c49995b3f60c2a1ced.svg";
export { ForwardRef as ReactComponent };